import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEnglishFlag = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 512 512",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "a",
		children: /* @__PURE__ */ _jsx("circle", {
			cx: 256,
			cy: 256,
			r: 256,
			fill: "#fff"
		})
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#a)",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				x: 0,
				y: 0,
				width: 512,
				height: 512,
				fill: "#fff"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#0052b4",
				d: "m47 0 142 142V0H47zm275 0v142l142-142h-142zM0 47v142h142L0 47zm512 0L370 189H512V47zM0 323v142l142-142H0zm370 0 142 142v-142H370zM189 370l-142 142h142V370zm134 0V512h142L323 370z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#d80027",
				d: "M223 0v223H0v67h223V512h67V290H512v-67H290V0h-67z        M0 0v31l158 158h32L0 0zm481 0L323 158v32L512 0h-31z        M189 323 0 512h31l158-158v-32zm134 0L512 512h0v-31L354 323h-32z"
			})
		]
	})]
});
export default SvgEnglishFlag;
